import { InjectionToken } from '@angular/core';

export const ACTING_ORGANIZATION_ID_PROVIDER = new InjectionToken<
  () => string | null
>('ACTING_ORGANIZATION_ID_PROVIDER', {
  providedIn: 'root',
  factory: () => () => null,
});
